import styled from 'styled-components';

export const SidebarHandle = styled.button`
  all: unset;
  box-sizing: border-box;
  overflow: hidden;

  width: 160px;
  height: 28px;
  margin: 4px 0px 24px 0;
  padding: 2px;
  margin-left: 22px;
  transition: all 0.2s;

  border-radius: 16px;
  background-color: ${({ theme }) => theme.color.surface.baseline};

  &:focus {
    outline: none;
    background-color: ${({ theme }) =>
      theme.createOverlayColor(theme.color.surface.baseline, 'focused')};
  }

  &:hover {
    cursor: pointer;
    background-color: ${({ theme }) =>
      theme.createOverlayColor(theme.color.surface.baseline, 'hover')};
  }

  .handle-inner {
    width: 160px;
    overflow: visible;
    display: flex;
    align-items: center;
    flex-direction: row;
  }

  div.handle {
    width: 24px;
    min-width: 24px;
    height: 24px;
    min-height: 24px;

    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;

    border-radius: 24px;
    background: ${({ theme }) => theme.color.tint.action};
  }

  div.close-text {
    color: ${({ theme }) => theme.color.tint.action};
    margin-left: 12px;
    transition: all 0.2s;
    padding-right: 8px;
  }

  .sidebar-collapsed & {
    width: 28px;

    div.handle {
      transform: rotate(180deg);
      transform-origin: center;
    }

    div.close-text {
      opacity: 0;
    }
  }
`;

export const SidebarSC = styled.aside`
  display: flex;
  flex-direction: column;
  position: fixed;
  overflow-x: hidden;

  top: 60px;
  left: 0;
  bottom: 0;

  width: 200px;
  overflow-y: auto;
  background: ${({ theme }) => theme.color.surface.backgroundDark};
  padding: 20px 0;
  transition: all 0.2s;

  .sidebar-collapsed & {
    width: 72px;
  }

  .inner {
    width: 200px;
  }

  .sidebar-bottom-logo {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 0 12px;
    height: 48px;
    z-index: 1;

    display: flex;
    align-items: center;
    justify-content: center;

    margin-bottom: 20px;
    background: ${({ theme }) => theme.color.surface.backgroundDark};
  }

  .side-nav-bar {
    overflow-y: auto;
    overflow-x: hidden;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
    ::-webkit-scrollbar {
      display: none;
    }
  }
`;
